import { ServiceUtil as serviceUtil, userService, SessionService, FinancialService, UserSession } from './'

export const ProfileApi = {
    getExtendedProfileInfo,
    saveAddress,
    saveExtendedProfile,
    getAccountDashboard,
    getFinancialBasis,
    saveExtendedUserProfile,

}

export const ProfileService = {
    loadExtendedProfileInfoInSession
    // getUserProfileExtendedFromNewLoanRequest,
    // loadExtendedProfileInfoInSession
}

function getExtendedProfileInfo() {
    return serviceUtil.executeServiceCall("ProfileAPI",
        "api/Profile/GetExtendedProfileInfo", serviceUtil.getRequest());
}


function saveAddress(newAddress) {
    return serviceUtil.executeServiceCall("ProfileAPI",
        "api/Profile/SaveAddress", serviceUtil.putRequest(newAddress));
}

function saveExtendedProfile(newProfile) {
    userService.setUserLanguage(newProfile.selectedLanguage);
    return serviceUtil.executeServiceCall("AccountAPI",
        "Account/SaveExtendedUserProfile", serviceUtil.postRequest(newProfile));
}

function getAccountDashboard() {
    return serviceUtil.executeServiceCall("ProfileAPI",
        "api/AccountDashboard/GetAccountDashboard", serviceUtil.getRequest())
        .then(response => {
            if (response.data && response.data.length > 0) {
                const loan = response.data[0];
                serviceUtil.setLocalBranchId(loan.sunLoanBranchId);
            }
            return response;
        });
}
function getFinancialBasis() {
    return getExtendedProfileInfo().then((result) => {
        if (!result.data) {
            return result;
        }
        const { employers, incomes } = result.data;
        let financialInfo = {
            primaryIncome: "",
            employer: "",
            yearsAtEmployer: "",
            monthsAtEmployer: "",
            employerStreetAddress: "",
            employerStreetAddress2: "",
            employerPostalCode: "",
            employerState: "",
            employerCity: "",
            workNumber: "",
            incomePerPeriod: "",
            payFrequency: "",
            otherIncomeSource: "",
            monthlyOtherIncome: "",
        };
        if (employers || incomes) {
            if (employers && employers.length > 0) {
                const [emp] = employers;
                financialInfo = {
                    primaryIncome: emp.primaryIncome || "",
                    employer: emp.employerName || "",
                    yearsAtEmployer: emp.yearsAtEmployer || "0",
                    monthsAtEmployer: emp.monthsAtEmployer || "0",
                    employerStreetAddress: emp.employerStreetAddress || "",
                    employerStreetAddress2: emp.employerStreetAddress2 || "",
                    employerPostalCode: emp.employerPostalCode || "",
                    employerState: emp.employerState || "",
                    employerCity: emp.employerCity || "",
                    workNumber: emp.workNumber || "",
                    incomePerPeriod: emp.incomePerPeriod || "",
                    payFrequency: emp.payFrequency || "",
                };
            }
            if (incomes && incomes.length > 0) {
                const [inc] = incomes;
                financialInfo = {
                    ...financialInfo,
                    otherIncomeSource: inc.incomeSource || "",
                    monthlyOtherIncome: inc.amount || "",
                };
            }
        }
        return { ...result, data: financialInfo };
    });
}


function saveExtendedUserProfile(userProfileExtended) {
    return serviceUtil.executeServiceCall("ProfileAPI",
        "api/Profile/SaveExtendedUserProfile", serviceUtil.postRequest(userProfileExtended));
}

// function getUserProfileExtendedFromNewLoanRequest() {
//   const currentSession = SessionService.getSession();
//   const {
//       userHash,
//       firstName,
//       lastName,
//       selectedLanguage,
//       bankruptcyFlag,
//       mobileOptIn,
//       suspendedFlag,
//       email,
//       mobilePhone,
//       fullName,
//       address1,
//       address2,
//       city,
//       state,
//       postalCode,
//       profileType,
//       monthsAtResidence,
//       yearsAtResidence,
//       ownResidence,
//       monthlyResidencePayment,
//   } = currentSession.personalInfo;
//   const {employers,
//       incomes } = currentSession;
//   return {
//       userHash,
//       firstName,
//       lastName,
//       selectedLanguage,
//       bankruptcyFlag,
//       mobileOptIn,
//       suspendedFlag,
//       email,
//       mobilePhone,
//       fullName,
//       address1,
//       address2,
//       city,
//       state,
//       postalCode,
//       profileType,
//       months: monthsAtResidence,
//       years : yearsAtResidence,
//       ownResidence : ownResidence ? ownResidence > 0 ? true : false : false,
//       monthlyResidencePayment,
//       employers : employers.map(employer=>{
//           const {
//               employerName,
//               yearsAtEmployer,
//               monthsAtEmployer,
//               employerStreetAddress,
//               employerStreetAddress2,
//               employerPostalCode,
//               employerState,
//               employerCity,
//               workNumber,
//               incomePerPeriod,
//               payFrequency,
//               primaryIncome,
//           } = employer
//           return {
//               employerName,
//               primaryIncomeSource: primaryIncome,
//               incomePerPeriod,
//               payFrequency,
//               workNumber,
//               years : yearsAtEmployer,
//               months : monthsAtEmployer,
//               address1 : employerStreetAddress,
//               address2 : employerStreetAddress2,
//               city :employerCity,
//               state :employerState ,
//               postalCode : employerPostalCode
//           };
//       }),
//       incomes : incomes.map(income=>{
//           const {
//               otherIncomeSource,
//               amount,
//               payFrequency,
//           } = income
//           return {
//               incomeSource : otherIncomeSource,
//               otherType : "",
//               amount,
//               frequency : payFrequency || FinancialService.PAY_FREQUENCY_MONTHLY,
//           };
//       }),
//   }
// }

/**
 * Normalize and storage the profile in session and return an instace of UserSession
 * @param profile {any}
 * @returns UserSession
 */
function loadExtendedProfileInfoInSession(profile) {
    const {
        accountID,
        userId,
        userHash,
        firstName,
        lastName,
        selectedLanguage,
        bankruptcyFlag,
        mobileOptIn,
        suspendedFlag,
        email,
        mobilePhone,
        fullName,
        address1,
        address2,
        city,
        state,
        postalCode,
        profileType,
        months,
        years,
        ownResidence,
        monthlyResidencePayment,
        employers,
        incomes,
        residenceType,
        addressId,
        branchId
    } = profile;
    const session = new UserSession({
        personalInfo: {
            accountID,
            userId,
            userHash,
            firstName,
            lastName,
            selectedLanguage,
            email,
            mobilePhone,
            fullName,
            address1,
            address2,
            city,
            state,
            postalCode,
            profileType,
            months,
            years,
            ownResidence,
            monthlyResidencePayment,
            bankruptcyFlag,
            mobileOptIn,
            suspendedFlag,
            residenceType,
            addressId,
            branchId
        },
        employers: employers
            ? employers.map((emp) => {
                emp.primaryIncome = emp.primaryIncomeSource;
                return emp;
            })
            : [],
        incomes: incomes ?
            incomes.map(inc => {
                return {
                    ...inc,
                    primaryIncome: FinancialService.PRIMARY_INCOME_SOURCE_NOTEMPLOYED,
                    otherIncomeSource: inc.incomeSource,
                    payFrequency: inc.payFrequency || FinancialService.PAY_FREQUENCY_MONTHLY
                }
            }) : [],
    })
    SessionService.setSession(session);
    return session;
}

// function getUserProfileExtendedFromUpdatePersonalInformation(personalInfo) {
//   const currentSession = SessionService.getSession();
//   const {
//       userHash,
//       firstName,
//       lastName,
//       selectedLanguage,
//       bankruptcyFlag,
//       mobileOptIn,
//       suspendedFlag,
//       email,
//       mobilePhone,
//       fullName,
//       address1,
//       address2,
//       city,
//       state,
//       postalCode,
//       profileType,
//       monthsAtResidence,
//       yearsAtResidence,
//       ownResidence,
//       monthlyResidencePayment,
//   } = personalInfo;
//   const {employers,
//       incomes } = currentSession;
//   return {
//       userHash,
//       firstName,
//       lastName,
//       selectedLanguage,
//       bankruptcyFlag,
//       mobileOptIn,
//       suspendedFlag,
//       email,
//       mobilePhone,
//       fullName,
//       address1,
//       address2,
//       city,
//       state,
//       postalCode,
//       profileType,
//       months: monthsAtResidence,
//       years : yearsAtResidence,
//       ownResidence : ownResidence ? ownResidence > 0 ? true : false : false,
//       monthlyResidencePayment,
//       employers,
//       incomes,
//   }
// }


// WEBPACK FOOTER //
// ./src/_services/profile.service.js